/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import styled from 'styled-components';
import { colorBackgroundBody } from '@/utils/palette';
import { paddingLeft } from '@/utils/directions';
import { canAccess } from '@/utils/services/authorization';
import Layout from '../Layout';

function ProtectedRoute({ allowedRoles, children, requiredPermissions, ...rest }) {
  const { isLoggedIn, user } = useSelector(state => state.user);

  return (
    <Route
      {...rest}
      render={({ location }) => (
        !isLoggedIn ? (
          <Redirect to={{ pathname: '/login', state: { from: location } }} />
        ) : canAccess({ session: user, allowedRoles, requiredPermissions }) ? (
          <div>
            <Layout />
            <ContainerWrap className="admin-page">{children}</ContainerWrap>
          </div>
        ) : (
          <Redirect to={{ pathname: '/forbidden', state: { from: location } }} />
        )
      )}
    />
  );
}

export default ProtectedRoute;
const ContainerWrap = styled.div`
  padding-top: 72px;
  min-height: 100vh;
  transition: padding-left 0.3s;

  ${paddingLeft}: 0;

  color: #cbd5e1;
  background:
    radial-gradient(circle at 88% 2%, rgba(99, 102, 241, .09), transparent 28%),
    #0b1020;

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 268px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;
